import * as React from 'react';

import classnames from 'classnames';

import {FormField} from 'shells/form/form-field';

import {GraphQLSelectActivityTypes} from '../../core/select/graphql-select-activity-types';
import {useUpdateSetting} from '../../core/use-update-setting';

import styles from './call-activity-type-select.module.css';

type Props = {
    activityTypeId: string | null | undefined;
    settingName: string;
    refetch?: () => Promise<any>;
    label: React.ReactNode | string;
    isHorizontal: boolean;
    autoFocus: boolean;
};

export function CallActivityTypeSelect(props: Props) {
    const [selectedActivityTypeId, setSelectedActivityTypeId] = React.useState(
        props.activityTypeId
    );

    React.useEffect(() => {
        setSelectedActivityTypeId(props.activityTypeId);
    }, [props.activityTypeId]);

    const [isSaving, setIsSaving] = React.useState(false);

    const updateSetting = useUpdateSetting();
    const labelStyle = classnames({
        [styles['horizontal-field-container']]: props.isHorizontal,
    });

    return (
        <div className={labelStyle}>
            <FormField
                innerId={`select-${props.settingName}`}
                label={props.label}
                noMargin={true}
                hasWrappingDiv={false}
                isFullWidth={false}
            >
                <GraphQLSelectActivityTypes
                    // @ts-expect-error
                    inputId={`select-${props.settingName}`}
                    selectedId={selectedActivityTypeId}
                    onChange={(value) => {
                        setSelectedActivityTypeId(value.id);
                        setIsSaving(true);
                        updateSetting({
                            settingName: props.settingName,
                            value: value.id,
                        })
                            .then(() => {
                                if (props.refetch) {
                                    props.refetch();
                                }
                            })
                            .finally(() => {
                                setIsSaving(false);
                            });
                    }}
                    placeholder='Select an activity type'
                    isLoading={isSaving}
                    autoFocus={props.autoFocus}
                />
            </FormField>
        </div>
    );
}
